import { fileTypesEnum } from "../../../../enums/errors/accounts/general/fileTypes.enum";
import FileInputElementComponent from "../../../general/elements/inputElements/FileInputElementComponent";

export const WebsiteConfigurationLogoSection = ({ props }) => {
  const { currentValue, handleChange } = props;

  const getLogoInputElement = () => {
    const inputProps = {
      label: "תמונת פריט ראשית",
      name: "Logo",
      value: currentValue.Url,
      fileType: fileTypesEnum.image,
      onChange: handleChange,
    };
    return <FileInputElementComponent props={inputProps} />;
  };

  return getLogoInputElement();
};

export default WebsiteConfigurationLogoSection;
